import React, { memo } from 'react';
import { Eye, Loader2 } from 'lucide-react';

interface CertificatePreviewProps {
  renderedHtml: string;
  isLoading: boolean;
  onIframeLoad: () => void;
}

export const CertificatePreview = memo(function CertificatePreview({ 
  renderedHtml,
  isLoading,
  onIframeLoad
}: CertificatePreviewProps) {
  return (
    <div className="h-full flex flex-col bg-background border-l">
      <div className="h-[50px] flex-none p-3 bg-muted/50 border-b flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Eye className="h-4 w-4" />
          <h3 className="text-sm font-medium">Live Preview</h3>
        </div>
        {isLoading && (
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Loader2 className="h-3 w-3 animate-spin" />
            <span>Updating...</span>
          </div>
        )}
      </div>
      
      <div className="flex-1 relative overflow-auto bg-muted/20">
        {renderedHtml ? (
          <iframe
            srcDoc={renderedHtml}
            onLoad={onIframeLoad}
            title="Certificate Preview"
            className="w-full h-full border-0"
            style={{
              minHeight: '600px',
              opacity: isLoading ? 0.6 : 1,
              transition: 'opacity 0.2s ease-in-out'
            }}
            sandbox="allow-same-origin"
          />
        ) : (
          <div className="flex items-center justify-center h-full text-muted-foreground">
            <p>Waiting for content to preview...</p>
          </div>
        )}
      </div>
    </div>
  );
});
